<mat-toolbar mat-dialog-title>
  <div>{{ 'search_news_tr' | translate }}</div>
  <mat-chip-listbox>
    @for (l of data.locations; track l) {
      <mat-chip class="location">
        <mat-icon>language</mat-icon>
        {{ l.name }}
      </mat-chip>
    }
    @for (r of data.risks; track r) {
      <mat-chip class="risk">
        <mat-icon>bolt</mat-icon>
        {{ r.name }}
      </mat-chip>
    }
  </mat-chip-listbox>
  <div style="flex-grow: 1"></div>
  <mat-icon mat-dialog-close>close</mat-icon>
</mat-toolbar>

<mat-dialog-content>
  <a tabindex="0">&nbsp;</a>

  @if (page.content.length === 0) {
    <h1>{{ 'no_news_found_tr' | translate }}</h1>
  }

  <ul>
    @for (e of page.content; track e) {
      <li>
        <div>
          <div>
            @if (e.imageData || thumbnails[e.id]; as thumbnail) {
              <img [attr.src]="thumbnail" alt="preview" width="130" />
            } @else {
              <mat-icon>web_asset_off</mat-icon>
            }
          </div>
          <div>
            {{ e.rating }}
          </div>
        </div>
        <div>
          <a [href]="e.source" target="_blank" rel="noopener noreferrer">
            <mat-icon>open_in_new</mat-icon>
            <h3>{{ e.title }}</h3>
          </a>
          <div class="clip" overflowGradient>{{ e.description }}</div>
          <mat-chip-listbox>
            @for (l of e.locations; track l) {
              <mat-chip class="location">
                <mat-icon>language</mat-icon>
                {{ l.name }}
              </mat-chip>
            }
            @for (r of e.risks; track r) {
              <mat-chip class="risk">
                <mat-icon>bolt</mat-icon>
                {{ r.name }}
              </mat-chip>
            }
          </mat-chip-listbox>
        </div>
      </li>
    }
  </ul>
  <app-paginator />
</mat-dialog-content>
